document.documentElement.classList.remove('no-js');

function esMoney(c){ return '$' + (c/100).toFixed(2).replace(/\.00$/,''); }
function esCatImg(t){
  t = (t||'').toLowerCase();
  if(t === 'women') return window.ES_ASSETS && ES_ASSETS.women;
  if(t === 'men')   return window.ES_ASSETS && ES_ASSETS.men;
  return window.ES_ASSETS && ES_ASSETS.unisex;
}
function esToggleBody(on){ document.body.classList.toggle('overlay-open', on); }

/* ---------- Menu drawer ---------- */
(function(){
  var d = document.querySelector('[data-drawer]'); if(!d) return;
  function open(){ d.classList.add('is-open'); esToggleBody(true); }
  function close(){ d.classList.remove('is-open'); if(!document.querySelector('.is-open')) esToggleBody(false); }
  document.querySelectorAll('[data-drawer-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
  document.querySelectorAll('[data-drawer-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
})();

/* ---------- Cart drawer (AJAX) ---------- */
var ESCart = (function(){
  var drawer = document.querySelector('[data-cart-drawer]');
  var body = document.querySelector('[data-cart-body]');
  var foot = document.querySelector('[data-cart-foot]');
  var subtotal = document.querySelector('[data-cart-subtotal]');
  var counts = document.querySelectorAll('[data-cart-count]');

  function open(){ if(drawer){ drawer.classList.add('is-open'); esToggleBody(true); } }
  function close(){ if(drawer){ drawer.classList.remove('is-open'); if(!document.querySelector('.is-open')) esToggleBody(false); } }

  function render(cart){
    counts.forEach(function(c){ c.textContent = cart.item_count; });
    if(!body) return;
    if(cart.item_count === 0){
      body.innerHTML = '<p class="cdrawer__empty">Your cart is empty.</p>';
      if(foot) foot.hidden = true;
      return;
    }
    if(foot) foot.hidden = false;
    body.innerHTML = cart.items.map(function(it){
      var img = (it.featured_image && it.featured_image.url) ? it.featured_image.url : (it.image || esCatImg(it.product_type) || '');
      return '<div class="cdrawer__row" data-key="'+it.key+'">'
        + '<img class="cdrawer__img" src="'+img+'" alt="">'
        + '<div class="cdrawer__info">'
        +   '<div class="cdrawer__name">'+it.product_title+'</div>'
        +   (it.variant_title ? '<div class="cdrawer__variant">'+it.variant_title+'</div>' : '')
        +   '<div class="cdrawer__qty">'
        +     '<button type="button" data-dec="'+it.key+'" aria-label="Decrease">&minus;</button>'
        +     '<span>'+it.quantity+'</span>'
        +     '<button type="button" data-inc="'+it.key+'" aria-label="Increase">+</button>'
        +   '</div>'
        +   '<button type="button" class="cdrawer__remove" data-remove="'+it.key+'">Remove</button>'
        + '</div>'
        + '<div class="cdrawer__price">'+esMoney(it.final_line_price)+'</div>'
        + '</div>';
    }).join('');
    if(subtotal) subtotal.textContent = esMoney(cart.total_price);
  }

  function fetchCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render); }
  function change(key, qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key, quantity:qty})}).then(function(r){return r.json();}).then(render);
  }
  function add(id, qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:id, quantity:qty||1})}).then(function(r){return r.json();}).then(function(){ return fetchCart(); }).then(open);
  }

  if(body){
    body.addEventListener('click', function(e){
      var inc=e.target.closest('[data-inc]'), dec=e.target.closest('[data-dec]'), rm=e.target.closest('[data-remove]');
      var row=e.target.closest('[data-key]'); if(!row) return;
      var qtySpan=row.querySelector('.cdrawer__qty span'); var q=parseInt(qtySpan?qtySpan.textContent:'1',10);
      if(inc) change(inc.getAttribute('data-inc'), q+1);
      else if(dec) change(dec.getAttribute('data-dec'), Math.max(0,q-1));
      else if(rm) change(rm.getAttribute('data-remove'), 0);
    });
  }
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
  document.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
  if(drawer) fetchCart();

  return { open:open, add:add, fetchCart:fetchCart };
})();

/* ---------- Add to cart (product form) ---------- */
(function(){
  var form = document.querySelector('.product-form'); if(!form) return;
  var select = form.querySelector('select[name="id"]');
  var priceEl = document.querySelector('[data-price]');
  var submit = form.querySelector('[data-add]');
  function update(){
    if(!select) return;
    var opt = select.options[select.selectedIndex];
    if(priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    if(submit){ var a = opt.dataset.available === 'true'; submit.disabled=!a; submit.textContent = a ? submit.dataset.label : 'Sold out'; }
  }
  if(select){ select.addEventListener('change', update); update(); }
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var id = select ? select.value : (form.querySelector('[name="id"]') || {}).value;
    if(!id) return;
    if(submit){ submit.disabled = true; submit.textContent = 'Adding…'; }
    ESCart.add(id, 1).then(function(){ if(submit){ submit.disabled=false; submit.textContent = submit.dataset.label; } })
      .catch(function(){ if(submit){ submit.disabled=false; submit.textContent = submit.dataset.label; } });
  });
})();

/* ---------- Search overlay (predictive) ---------- */
(function(){
  var wrap = document.querySelector('[data-search]'); if(!wrap) return;
  var input = wrap.querySelector('[data-search-input]');
  var results = wrap.querySelector('[data-search-results]');
  function open(){ wrap.classList.add('is-open'); esToggleBody(true); setTimeout(function(){ if(input) input.focus(); }, 60); }
  function close(){ wrap.classList.remove('is-open'); if(!document.querySelector('.is-open')) esToggleBody(false); }
  document.querySelectorAll('[data-search-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); open(); }); });
  document.querySelectorAll('[data-search-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

  var t;
  function search(q){
    if(!q || q.length < 2){ results.innerHTML=''; return; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(data){
      var items = (data.resources && data.resources.results && data.resources.results.products) || [];
      if(!items.length){ results.innerHTML = '<p class="searchbar__empty">No matches for "'+q+'".</p>'; return; }
      results.innerHTML = items.map(function(p){
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || (window.ES_ASSETS&&ES_ASSETS.unisex) || '');
        var price = p.price ? esMoney(parseInt(p.price,10)) : '';
        return '<a class="searchbar__result" href="'+p.url+'">'
          + '<img src="'+img+'" alt="">'
          + '<span class="searchbar__rname">'+p.title+'</span>'
          + '<span class="searchbar__rprice">'+price+'</span></a>';
      }).join('');
    }).catch(function(){});
  }
  if(input){ input.addEventListener('input', function(){ clearTimeout(t); var q=input.value.trim(); t=setTimeout(function(){ search(q); }, 220); }); }
})();
